import { BtixConstant } from "../constant";
// モーダル開閉
export const initModalControl = () => {
    initModalOpener();
    initModalCloser();
};
const initModalOpener = () => {
    const openButtons = document.querySelectorAll(".modal-open");
    if (!openButtons)
        throw new Error("'openButtons' is not found.");
    for (const openButton of openButtons) {
        window.console.log("init openButton: ", openButton);
        openButton.addEventListener(BtixConstant.touchOrClickEvent(), () => {
            const modalArea = document.querySelector("#" + openButton.dataset.modalTarget);
            if (!modalArea)
                throw new Error("'modalArea' is not found.");
            modalArea.classList.add("is-show");
        });
    }
};
const initModalCloser = () => {
    const closeButtons = document.querySelectorAll(".modal-close");
    if (!closeButtons)
        throw new Error("'closeButtons' is not found.");
    for (const closeButton of closeButtons) {
        window.console.log("init closeButton: ", closeButton);
        closeButton.addEventListener(BtixConstant.touchOrClickEvent(), () => {
            const modalArea = closeButton.closest(".modal-area");
            if (!modalArea)
                throw new Error("'modalArea' is not found.");
            modalArea.classList.remove("is-show");
        });
    }
    // モーダル枠外押下等で閉じる処理（modal-closeクラスにはcssが適用されていたため別のクラスを追加）
    const closeSubButtons = document.querySelectorAll(".modal-close-sub");
    if (!closeSubButtons)
        throw new Error("'closeSubButton' is not found.");
    for (const closeSubButton of closeSubButtons) {
        window.console.log("init closeButton: ", closeSubButton);
        closeSubButton.addEventListener(BtixConstant.touchOrClickEvent(), () => {
            const modalArea = closeSubButton.closest(".modal-area");
            if (!modalArea)
                throw new Error("'modalArea' is not found.");
            modalArea.classList.remove("is-show");
        });
    }
};
